export const firebaseConfig = {
  apiKey: "AIzaSyBViSgeCPz_q2aolDdF4tZdsYPaGYyRx7E",
  authDomain: "red-flag-or-deal-breaker.firebaseapp.com",
  projectId: "red-flag-or-deal-breaker",
  storageBucket: "red-flag-or-deal-breaker.appspot.com",
  messagingSenderId: "388632726152",
  appId: "1:388632726152:web:9baf06c6804de012276d3d",
  measurementId: "G-LXBRWJ7RZT",
};

export default firebaseConfig;
